"use client";

import { Card, CardContent, CardHeader, CardTitle, Input, Label } from "@aio/platform-ui";
import { LocaleSwitcher, latnToCyrl, useLocale, formatNumber, formatDate, formatCurrency } from "@aio/platform-i18n";
import { useState } from "react";

export default function I18nShowcase() {
  const { locale } = useLocale();
  const [text, setText] = useState("Računovodstvo i knjigovodstvo");
  const now = new Date();
  return (
    <div className="space-y-6">
      <header className="flex items-start justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">i18n</h1>
          <p className="mt-1 text-fg-muted">Locale: {locale}</p>
        </div>
        <LocaleSwitcher />
      </header>
      <Card>
        <CardHeader>
          <CardTitle as="h2">Transliterator</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="latn">sr-Latn</Label>
            <Input id="latn" value={text} onChange={(e) => setText(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="cyrl">sr-Cyrl (auto-derived)</Label>
            <Input id="cyrl" readOnly value={latnToCyrl(text)} />
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle as="h2">Formatters</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 font-mono text-sm">
          <div>Number: {formatNumber(locale, 1234567.89)}</div>
          <div>Currency (RSD): {formatCurrency(locale, 1234567.89, "RSD")}</div>
          <div>Currency (EUR): {formatCurrency(locale, 1234.56, "EUR")}</div>
          <div>Date: {formatDate(locale, now)}</div>
          <div>Date (long): {formatDate(locale, now, { dateStyle: "full" })}</div>
        </CardContent>
      </Card>
    </div>
  );
}
